// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// import { getFireStore } from "firebase/firestore";

// import firebase from "firebase/compat/app";
// import "firebase/compat/auth";
// import "firebase/compat/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCefrnPndSXMAvUxWktWGZ0ghyjhGzKpQc",
  authDomain: "sona-6b3c9.firebaseapp.com",
  projectId: "sona-6b3c9",
  storageBucket: "sona-6b3c9.appspot.com",
  messagingSenderId: "946730228701",
  appId: "1:946730228701:web:9f8a28cef514c163ffb434",
  measurementId: "G-Y7ZRGS2QK0",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
